import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import BrandStrip from "@/components/site/BrandStrip";
import Divisions from "@/components/site/Divisions";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Logistics from "@/components/site/Logistics";
import Founder from "@/components/site/Founder";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import useReveal from "@/hooks/useReveal";

const Home = () => {
  useReveal();
  return (
    <main data-testid="home-page" className="bg-[#050914] text-white">
      <Nav />
      <Hero />
      <BrandStrip />
      <Divisions />
      <About />
      <Services />
      <Logistics />
      <Founder />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0a1324",
            border: "1px solid rgba(212, 175, 55, 0.25)",
            color: "#f8fafc",
            fontFamily: "Manrope, sans-serif",
            borderRadius: "0",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
